import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router'
import clsx from 'clsx'
import { AsideMenuAdmin } from './AsideMenuAdmin'
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components'
import { useAuth } from '../../../../app/contexts/AuthProvider'
import { AsideMenuMaster } from './AsideMenuMaster'
import { AsideMenuAnalista } from './AsideMenuAnalista'

function AsideMenu({ asideMenuCSSClasses, setItensAdicionais }: { asideMenuCSSClasses: string[], setItensAdicionais: React.Dispatch<React.SetStateAction<JSX.Element[]>> }) {
  const { usuario } = useAuth();
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const { pathname } = useLocation()

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0
      }
    }, 50)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  function escolherMenu() {
    switch (usuario?.perfil) {
      case 'Administrador':
        return <AsideMenuAdmin />
      case 'Analista':
        return <AsideMenuAnalista />
      case 'Master':
        return <AsideMenuMaster setItensAdicionais={setItensAdicionais} />
      default:
        return <div style={{ textAlign: 'center', color: 'white' }}>
          Não existem Menu configurado<br /> para esse perfil de usuário
        </div>
    }
  }

  return (
    <div
      id='kt_aside_menu_wrapper'
      ref={scrollRef}
      className='hover-scroll-overlay-y my-5 my-lg-5'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-height='auto'
      data-kt-scroll-dependencies='#kt_aside_logo, #kt_aside_footer'
      data-kt-scroll-wrappers='#kt_aside_menu'
      data-kt-scroll-offset='0'
    >
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className={clsx(
          'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
          asideMenuCSSClasses.join(' ')
        )}
      >
        {escolherMenu()}
      </div>
    </div>
  )
}

export { AsideMenu }
